/*
 * Copyright (c) webzuu Michał Stambulski 2018.
 */

import React from "react";
import { thumbnail } from "util/thumbnail";
import FileTypeIcon from "./FileTypeIcon";

import * as fileUtils from "util/file";

const thumbnailExtensions = ["jpg", "jpeg", "gif", "png", "JPG", "JPEG", "blob", "svg"];

export default function FilePreview(props) {

  let {file, mediaType, style: propsStyle, className: propsClassName} = props;
  let extension = fileUtils.extension(file);
  let icon = null;

  let style = {
    width: "100%",
    height: "100%",
    ...propsStyle
  };

  let className = propsClassName || '';
  className += ' file-preview';

  if (thumbnailExtensions.indexOf(extension) > -1 || mediaType === 'image') {
    let thumbUrl = extension === "blob" ? file : thumbnail(file, [200, 150]);
    style = {
      ...style,
      backgroundImage: 'url("' + thumbUrl + '")',
      backgroundSize: "cover",
      backgroundPosition: "center center",
      backgroundRepeat: "no-repeat",
      color: 'white'
    };
    if (extension === 'svg' || extension === 'png') {
      style.backgroundSize = 'contain';
    }
    icon = mediaType ? <FileTypeIcon type={mediaType} /> : null
  } else {
    style.display = "flex";
    style.alignItems = "center";
    style.justifyContent = "center";
    icon = <FileTypeIcon extension={extension} />;
  }

  return <div className={className} style={style}>{icon}</div>;
}

FilePreview.defaultProps = {
  style: {}
}
